import { Component, OnInit } from '@angular/core';
import { ProductSlider, ProductSlider2 } from '../../../shared/data/slider';
import { SliderService } from '../../../shared/services/slider.service';
import { SliderModel } from '../../../shared/models/slider.model';
import { Product } from '../../../shared/classes/product';
import { ProductService } from '../../../shared/services/product.service';
import {ActivityService} from '../../../Islamic-Center/Activites/activity.service';
import { WorkshopsService } from 'src/app/shared/components/Islamic-center/workshops.service';
import { WorkshopsModel } from 'src/app/shared/components/Islamic-center/WorkshopsModel';
import { ActivityModel } from 'src/app/Islamic-Center/Activites/ActivityModel';
import { ManagersService } from 'src/app/Islamic-Center/Master-Data/Managers/managers.service';
import { ManagersModel } from 'src/app/Islamic-Center/Master-Data/Managers/ManagersModel';
import { GalleryService } from '../../../Islamic-Center/Gallery/gallery.service'
import { GalleryModel } from 'src/app/Islamic-Center/Gallery/GalleryModel';
import { BannerService } from '../../banner-helper/banner.service';
import { BannerModel } from '../../banner-helper/banner.model';
import { NewsService } from 'src/app/Islamic-Center/news/news.service';
import { NewsModel } from 'src/app/Islamic-Center/news/model/news.model';
@Component({
  selector: 'app-fashion-one',
  templateUrl: './fashion-one.component.html',
  styleUrls: ['./fashion-one.component.scss']
})
export class FashionOneComponent implements OnInit {

  public products: Product[] = [];
  public WorkshopsList: WorkshopsModel[] = [];
  public productCollections: any[] = [];
  public active;
  public themeLogo: string = 'assets/images/MyImage/logo.png';
banner:BannerModel={};
managers:ManagersModel[]=[];
  constructor(public productService: ProductService,
    private ActivityService:ActivityService,
    private workshopeService:WorkshopsService,
    private ManagersService :ManagersService,
    private GalleryService:GalleryService,
    private SliderService:SliderService,
    private bannerService:BannerService,
    private newsService:NewsService

    ) {
      this.lang = localStorage.getItem('theme_lang');
    this.productService.getProducts.subscribe(response => {
      this.products = response.filter(item => item.type == 'fashion');
      // Get Product Collection
      this.products.filter((item) => {
        item.collection.filter((collection) => {
          const index = this.productCollections.indexOf(collection);
          if (index === -1) this.productCollections.push(collection);
        })
      })
    });
  }
  slider:SliderModel[]=[];
  public ProductSliderConfig: any = ProductSlider;
  public ProductSliderConfig2: any = ProductSlider2;
  public ProductSliderConfig3: any = ProductSlider;

  public sliders = [{
    title: 'Assisted fertility programs',
    subTitle: 'Islamic Center',
    image: 'assets/images/slider/slider2.jpg'
  }, {
    title: 'Assisted fertility programs',
    subTitle: 'Islamic Center',
    image: 'assets/images/slider/slider2.jpg'
  }]

  // Collection banner
  public collections = [{
    image: 'assets/images/collection/fashion/1.jpg',
    save: 'save 50%',
    title: 'men'
  }, {
    image: 'assets/images/collection/fashion/2.jpg',
    save: 'save 50%',
    title: 'women'
  },];
  lang='';
  // Blog
  public blog = [{
    image: 'assets/images/blog/1.png',
    date: '2 April 2020',
    title: 'Phto description 1 International Visits',
    by: 'John Dio'
  }, {
    image: 'assets/images/blog/2.png',
    date: '4 April 2020',
    title: 'International Islamic Center',
    by: 'John Dio'
  }, {
    image: 'assets/images/blog/3.png',
    date: '15 march 2023',
    title: 'International Islamic Center',
    by: 'John Dio'
  }];

  // Logo
  public logo = [{
    image: 'assets/images/logos/1.png',
  }, {
    image: 'assets/images/logos/2.png',
  }, {
    image: 'assets/images/logos/3.png',
  }, {
    image: 'assets/images/logos/4.png',
  }, {
    image: 'assets/images/logos/5.png',
  }, {
    image: 'assets/images/logos/6.png',
  }, {
    image: 'assets/images/logos/7.png',
  }, {
    image: 'assets/images/logos/8.png',
  }];
  GalleryList:GalleryModel[]=[];
  ngOnInit(): void {
    debugger;
    this.bannerService.get()
    .subscribe(result =>{
      this.banner = result;
    })
    this.SliderService.getAll()
    .subscribe(result=>{
      this.slider = result;
    })
    this.GalleryService.GetLastTwo().subscribe(data=>{
      this.GalleryList=data;
    })
    this.workshopeService.GetLastFour().subscribe(data=>{
      this.WorkshopsList=data;
      //console.log("WorkshopsList",this.WorkshopsList)
  })
  this.ActivityService.GetLastFour().subscribe(data=>{
    this.ActivityList=data;
    // console.log("ActivityList",this.ActivityList)

  })
  this.ManagersService.GetLastFour()
  .subscribe(result=>{
    this.managers = result;
  })
  this.newsService.GetLastFour().subscribe(data=>{
    this.NewsList=data;
    //console.log("modelObject",this.rows)
  })
  }
  NewsList:NewsModel[]=[];
  // Product Tab collection
  getCollectionProducts(collection) {
    return this.products.filter((item) => {
      if (item.collection.find(i => i === collection)) {
        return item
      }
    })
    // this.ActivityService.getAll().subscribe(data=>{
//   this.ActivityList=data;
//   //console.log("ActivityList",this.ActivityList)
// })
  }
  
  ActivityModel: ActivityModel = new ActivityModel();
  ActivityList:ActivityModel[]=[];

}
